export default __webpack_public_path__ + "static/media/Gallery10.0692ffd4.jpg";